import currentArtwork from './product_builder/currentArtwork';
import currentCategory from './product_builder/currentCategory';
import currentFaceplateOption from './product_builder/currentFaceplateOption';
import currentFaceplateType from './product_builder/currentFaceplateType';
import currentShell from './product_builder/currentShell';
import currentCableOption from './product_builder/currentCable';
import finalizeForm from './product_builder/finalizeForm';
import modelList from './product_builder/modelList';
import currentModel from './product_builder/currentModel';
import settingsOptions from './product_builder/settingsOptions';
import iemPrice from './product_builder/iemPrice';
import summaryCategoryState from './product_builder/summaryState';
import impressionStatusList from './product_builder/impressionStatus';
import rushOptionsList from './product_builder/rushOptions';
import customLayer from './product_builder/customArtworkLayer';
import preview from './product_builder/preview';
import { combineReducers } from 'redux';

const rootReducer = combineReducers({
    modelList,
    currentModel,
    currentArtwork,
    currentCategory,
    currentFaceplateOption,
    currentFaceplateType,
    currentShell,
    currentCableOption,
    finalizeForm,
    settingsOptions,
    iemPrice,
    summaryCategoryState,
    impressionStatusList,
    rushOptionsList,
    customLayer,
    preview
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
